import moment from 'jalali-moment';

export const timeFromCreated = (createdAt: string) => {
  const dateTime = moment(moment(new Date(createdAt)))
    .locale('fa')
    .fromNow();
  return dateTime;
};
